import { render, staticRenderFns } from "./OpenNeed.vue?vue&type=template&id=101a8a14"
import script from "./OpenNeed.vue?vue&type=script&lang=ts"
export * from "./OpenNeed.vue?vue&type=script&lang=ts"
import style0 from "./OpenNeed.vue?vue&type=style&index=0&id=101a8a14&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports